import { forwardRef, type JSX, type ReactNode } from "react";

import { cn } from "@/lib/cn";

import { Button, type ButtonProps } from "./button";

export interface IconButtonProps extends Omit<ButtonProps, "size" | "children"> {
  /** Required: an icon has no text, so the name is what assistive technology reads. */
  label: string;
  children: ReactNode;
}

/** A square button holding one Lucide icon. The label is mandatory. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, children, variant = "ghost", className, ...rest },
  ref,
): JSX.Element {
  return (
    <Button
      ref={ref}
      variant={variant}
      size="md"
      aria-label={label}
      title={label}
      className={cn("size-9 p-0", className)}
      {...rest}
    >
      {children}
    </Button>
  );
});
